import { memo } from 'react';

import { merge } from '@/components';
import { Badge, Button, ButtonProps, Text } from '@/components/core';
import { TriggerLogo } from '@/components/logos';
import { JSONType, OmitChildren } from '@/utils';

export type TriggerOption = {
  functionId: string;
  name: string;
  config: JSONType | (() => JSONType);
  description?: string;
  badge?: string;
  isFakeImport?: boolean;
};

export type TriggerCellProps = OmitChildren<ButtonProps> & {
  option: TriggerOption;
};

const ITriggerCell = ({ option, className, ...rest }: TriggerCellProps) => {
  return (
    <Button className={merge('w-full !justify-start', className)} {...rest}>
      <TriggerLogo size="xl" functionId={option.functionId} />
      <div className="flex flex-col items-start">
        <Text>{option.name}</Text>
        <Text className="!font-regular text-start !text-gray-500" size="xs">
          {option.description}
        </Text>
      </div>
      {option.badge ? (
        <>
          <div className="grow" />
          <Badge variant="default" label={option.badge} />
        </>
      ) : null}
    </Button>
  );
};

export const TriggerCell = memo(ITriggerCell) as typeof ITriggerCell;
